import React from 'react';
import { useTranslation } from 'react-i18next';

import { InfoBox } from '../../info-box/info-box';

const OneMoment = () => {
  const { t } = useTranslation();

  return (
    <InfoBox color="yellow" leftIcon={{ icon: ['fad', 'spinner'], spin: true }}>
      {t('oneMoment', { ns: 'common' })}
    </InfoBox>
  );
};

export { OneMoment };
